export default "__VITE_ASSET__CptzFMg$__"